import React from 'react';
import QRCode from 'qrcode.react';
import {showSuccessMsg} from '../../util/messagesUtil';

// QR Code PIX Sicoob de Encomenda, Encomenda Avulsa e Excesso de Bagagem: o endpoint
// .../cadastrar/terminal-venda-sicoob cria o registro e já devolve o copia e cola (igual a
// pagarPedidoSicoob em Vender Passagens); aqui só é exibido e acompanhado por polling, como em
// PainelVenderPassagem.verificarPagamento. Cada serviço passa a sua própria consulta de
// situação (verificarPagamento), do seu controller -- não usa endpoint de reserva.
// pedidos: [{ id, copiaECola, descricao }], id = encomenda/encomenda avulsa/bagagem (a
// bagagem pode gerar um registro por passageiro)
export default class PagamentoPixSicoob extends React.Component {
  constructor(props) {
    super(props);
    this.state = { situacoes: {} };
  }

  componentDidMount() {
    this.pollingInterval = setInterval(() => this.verificarPagamentos(), 15000);
  }

  componentWillUnmount() {
    clearInterval(this.pollingInterval);
  }

  verificarPagamentos() {
    this.props.pedidos.filter(p => !this.state.situacoes[p.id]).forEach(p => {
      this.props.verificarPagamento(p.id).then(resp => {
        const situacao = resp.payload.data;
        if (situacao === 'APROVADO' || situacao === 'CANCELADO') {
          this.setState(state => ({ situacoes: { ...state.situacoes, [p.id]: situacao } }),
            () => this.verificarConclusao());
        }
      });
    });
  }

  verificarConclusao() {
    if (this.props.pedidos.every(p => this.state.situacoes[p.id] === 'APROVADO')) {
      clearInterval(this.pollingInterval);
      showSuccessMsg('Pagamento Sicoob PIX confirmado!');
      this.props.onConcluido();
    }
  }

  exibirPagamento(pedido) {
    const situacao = this.state.situacoes[pedido.id];
    if (situacao === 'APROVADO') {
      return (
        <div className="vx-summary-waiting">
          <i className="material-icons">check_circle</i>
          Pagamento confirmado
        </div>
      );
    }
    if (situacao === 'CANCELADO') {
      return (
        <div className="vx-summary-tef-alert">
          <i className="material-icons">error</i>
          <span>Pagamento cancelado sem confirmação.</span>
        </div>
      );
    }
    return (
      <React.Fragment>
        <QRCode value={pedido.copiaECola} size={180} />
        <p className="vx-summary-qr-url">{pedido.copiaECola}</p>
        <div className="vx-summary-qr-actions">
          <button type="button" className="vx-summary-qr-copy-btn"
                  onClick={() => navigator.clipboard.writeText(pedido.copiaECola)}>
            <i className="material-icons" style={{ fontSize: '16px' }}>content_copy</i>
            Copiar Código PIX
          </button>
        </div>
        <div className="vx-summary-waiting">
          <i className="material-icons">sync</i>
          Aguardando confirmação do pagamento...
        </div>
      </React.Fragment>
    );
  }

  render() {
    return (
      <div>
        {this.props.pedidos.map(pedido => (
          <div key={pedido.id} className="vx-summary-qr-card mb-3">
            <div className="vx-summary-qr-title">
              <i className="material-icons">check_circle</i>
              QR Code PIX gerado! {pedido.descricao ? `— ${pedido.descricao}` : ''}
            </div>
            {this.exibirPagamento(pedido)}
          </div>
        ))}
      </div>
    );
  }
}
